import {useNavigate} from '@github-ui/use-navigate'
import {type RefObject, useCallback, useState} from 'react'

import {DuplicateSavedViewDialog} from '../components/views/DuplicateSavedViewDialog'
import type {SavedView} from '../components/views/types'

interface UseDuplicateSavedViewDialogOptions {
  owner: string
  repo: string
  returnFocusRef?: RefObject<HTMLElement | null>
}

export function useDuplicateSavedViewDialog({owner, repo, returnFocusRef}: UseDuplicateSavedViewDialogOptions) {
  const navigate = useNavigate()
  const [pendingDuplicate, setPendingDuplicate] = useState<SavedView | null>(null)

  const openDuplicateDialog = useCallback((view: SavedView) => {
    setPendingDuplicate(view)
  }, [])

  const duplicateDialog = pendingDuplicate ? (
    <DuplicateSavedViewDialog
      view={pendingDuplicate}
      owner={owner}
      repo={repo}
      onClose={() => setPendingDuplicate(null)}
      onSuccess={newView => navigate(`/${owner}/${repo}/issues/views/${newView.id}`)}
      returnFocusRef={returnFocusRef}
    />
  ) : null

  return {openDuplicateDialog, duplicateDialog}
}
